const legalCompanyProfileTranslations = {
  en: {
    legalCompanyIdentity: "Verified legal identity",
    legalCompanyIdentityHelp: "Used in controlled legal documents. Enter only verified registration information.",
    legalCompanyName: "Registered legal name",
    tradingName: "Trading name",
    companyRegistrationNumber: "Company registration number",
    taxNumber: "Tax number",
    impicLicenseNumber: "IMPIC licence number",
    registeredAddress: "Registered office",
    legalEmail: "Legal email",
    legalPhone: "Legal telephone",
    website: "Website",
    defaultGoverningLaw: "Default governing law",
    defaultControllingLanguage: "Default controlling language",
  },
  pt: {
    legalCompanyIdentity: "Identidade jurídica verificada",
    legalCompanyIdentityHelp: "Utilizada em documentos jurídicos controlados. Introduza apenas dados de registo verificados.",
    legalCompanyName: "Denominação social registada",
    tradingName: "Nome comercial",
    companyRegistrationNumber: "Número de registo comercial",
    taxNumber: "Número de identificação fiscal",
    impicLicenseNumber: "Número de licença IMPIC",
    registeredAddress: "Sede social",
    legalEmail: "Email jurídico",
    legalPhone: "Telefone jurídico",
    website: "Website",
    defaultGoverningLaw: "Lei aplicável predefinida",
    defaultControllingLanguage: "Idioma prevalecente predefinido",
  },
  zh: {
    legalCompanyIdentity: "经核实的法律主体信息",
    legalCompanyIdentityHelp: "用于受控法律文件。请仅填写已经核实的注册资料。",
    legalCompanyName: "注册法定名称",
    tradingName: "商业名称",
    companyRegistrationNumber: "公司注册编号",
    taxNumber: "税务编号",
    impicLicenseNumber: "IMPIC 许可证编号",
    registeredAddress: "注册办事处",
    legalEmail: "法律事务邮箱",
    legalPhone: "法律事务电话",
    website: "网站",
    defaultGoverningLaw: "默认适用法律",
    defaultControllingLanguage: "默认准据语言",
  },
  fr: {
    legalCompanyIdentity: "Identité juridique vérifiée",
    legalCompanyIdentityHelp: "Utilisée dans les documents juridiques contrôlés. Saisissez uniquement des informations d’enregistrement vérifiées.",
    legalCompanyName: "Dénomination sociale enregistrée",
    tradingName: "Nom commercial",
    companyRegistrationNumber: "Numéro d’immatriculation de la société",
    taxNumber: "Numéro fiscal",
    impicLicenseNumber: "Numéro de licence IMPIC",
    registeredAddress: "Siège social",
    legalEmail: "Email juridique",
    legalPhone: "Téléphone juridique",
    website: "Site internet",
    defaultGoverningLaw: "Droit applicable par défaut",
    defaultControllingLanguage: "Langue faisant foi par défaut",
  },
  es: {
    legalCompanyIdentity: "Identidad jurídica verificada",
    legalCompanyIdentityHelp: "Utilizada en documentos jurídicos controlados. Introduzca únicamente información registral verificada.",
    legalCompanyName: "Denominación social registrada",
    tradingName: "Nombre comercial",
    companyRegistrationNumber: "Número de registro mercantil",
    taxNumber: "Número fiscal",
    impicLicenseNumber: "Número de licencia IMPIC",
    registeredAddress: "Domicilio social",
    legalEmail: "Correo jurídico",
    legalPhone: "Teléfono jurídico",
    website: "Sitio web",
    defaultGoverningLaw: "Ley aplicable predeterminada",
    defaultControllingLanguage: "Idioma prevalente predeterminado",
  },
  de: {
    legalCompanyIdentity: "Verifizierte rechtliche Identität",
    legalCompanyIdentityHelp: "Wird in kontrollierten Rechtsdokumenten verwendet. Geben Sie nur geprüfte Registerangaben ein.",
    legalCompanyName: "Eingetragener Firmenname",
    tradingName: "Handelsname",
    companyRegistrationNumber: "Handelsregisternummer",
    taxNumber: "Steuernummer",
    impicLicenseNumber: "IMPIC-Lizenznummer",
    registeredAddress: "Eingetragener Sitz",
    legalEmail: "E-Mail für Rechtsangelegenheiten",
    legalPhone: "Telefon für Rechtsangelegenheiten",
    website: "Website",
    defaultGoverningLaw: "Standardmäßig anwendbares Recht",
    defaultControllingLanguage: "Standardmäßig maßgebliche Sprache",
  },
  it: {
    legalCompanyIdentity: "Identità giuridica verificata",
    legalCompanyIdentityHelp: "Utilizzata nei documenti legali controllati. Inserire esclusivamente informazioni di registrazione verificate.",
    legalCompanyName: "Denominazione legale registrata",
    tradingName: "Nome commerciale",
    companyRegistrationNumber: "Numero di registrazione della società",
    taxNumber: "Numero fiscale",
    impicLicenseNumber: "Numero di licenza IMPIC",
    registeredAddress: "Sede legale",
    legalEmail: "Email legale",
    legalPhone: "Telefono legale",
    website: "Sito web",
    defaultGoverningLaw: "Legge applicabile predefinita",
    defaultControllingLanguage: "Lingua prevalente predefinita",
  },
  ru: {
    legalCompanyIdentity: "Проверенные юридические данные",
    legalCompanyIdentityHelp: "Используются в контролируемых юридических документах. Вносите только проверенные регистрационные сведения.",
    legalCompanyName: "Зарегистрированное юридическое наименование",
    tradingName: "Коммерческое наименование",
    companyRegistrationNumber: "Регистрационный номер компании",
    taxNumber: "Налоговый номер",
    impicLicenseNumber: "Номер лицензии IMPIC",
    registeredAddress: "Юридический адрес",
    legalEmail: "Юридический email",
    legalPhone: "Юридический телефон",
    website: "Веб-сайт",
    defaultGoverningLaw: "Применимое право по умолчанию",
    defaultControllingLanguage: "Преобладающий язык по умолчанию",
  },
};

export default legalCompanyProfileTranslations;
